<template>
  <div
    class="project-autopilots-details"
    v-if="autopilotprojects"
  >
    <div class="project-autopilots-details-head">
      <!-- Page Title -->
      <TText
        :text="autopilot.function"
        font_weight="500"
        size="24"
      />

      <!-- Play/Pause -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <!-- Icon-Button -->
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            @click="updateUObject({
              url: [
                { projects: project_id },
                { autopilotprojects: autopilotprojects.id }
              ],
              update: {
                active: !autopilotprojects.active
              }
            })"
          >
            <v-icon>
              {{ autopilotprojects.active ? 'mdi-play' : 'mdi-pause'}}
            </v-icon>
          </v-btn>
        </template>

        <!-- Tooltip -->
        <span>
          {{ autopilotprojects.active ? 'currently active' : 'currently paused' }}
        </span>
      </v-tooltip>
    </div>

    <!-- Level Matrix -->
    <!-- NOTE: WIP -->
    <div style="display: flex; grid-gap: 8px; align-items: center;">
      <!-- {{autopilot}} -->
      <!-- NOTE: we want to change the level here, currently there is only the active level -->
      <!-- <RadioKnobRow
        :knobs="autopilot.levels"
        :selected_id="autopilot.mapped_autopilot.id"
        :cell_count="4"
        :is_disabled="!autopilot.active"
        :height="cell_height"
        :width="cell_width"
        @knobClicked="
          autopilot.mapped_autopilot.id !== level.id?
          updateUObject({
            url: [
            {projects: project.id},
            {autopilotprojects: autopilot.id}
            ],
            update: {
              ['add#autopilots']: [level.id]
            }
          }).then(() => {
            updateUObject({
              url: [
              {projects: project.id},
              {autopilotprojects: autopilot.id}
              ],
              update: {
                ['remove#autopilots']: [autopilot.autopilots[0]]
              }
            })
            })
          :
          ''"
      /> -->

      <v-btn
        v-for="level in getUObjectsFiltered({type: 'autopilots', filter: {function: autopilot.function}})"
        :key="`aplevel${level.id}`"
        small
        class="ml-1"
        :color="autopilot.id === level.id?'green':''"
        @click="
          autopilot.id !== level.id?
          updateUObject({
            url: [
            {projects: project_id},
            {autopilotprojects: autopilotprojects.id}
            ],
            update: {
              'add#autopilots': [level.id]
            }
          }).then(() => {
            updateUObject({
              url: [
              {projects: project_id},
              {autopilotprojects: autopilotprojects.id}
              ],
              update: {
                'remove#autopilots': [autopilotprojects.autopilots[0]]
              }
            })
            })
          :
          ''
        "
      >
        {{ level.level }}
      </v-btn>
    </div>

    <!-- Description -->
    <!-- NOTE: What do we show here? Is a simple text even enough? -->
    <TText
      :text="autopilot.description"
      font_weight="400"
    />

    <!-- Remove Button -->
    <ButtonOutlined
      text="Remove"
      icon="bin"
      color="red"
      width="128"
      height="36"
      @buttonClicked="deleteUObject({
        url: [
          { projects: project_id },
          { autopilotprojects: autopilotprojects.id },
        ]
        }).then(() => {
          $router.push({name: 'ProjectAutoPilots'})
        })"
    />


    <!-- TWP Mappers FOR THIS PILOT -->
    <TText
      :text="'WORK.package mappers'"
      font_weight="500"
      size="24"
    />
    <TFlex wrap="wrap">
      <TWPMapper
        v-for="twpmapper in getUObjects({ type: 'twpmappers', ids: getUObject({type:'autopilotprojects', id: $route.params.autopilot_id}).twpmappers})"
        :key="`twpmappers${twpmapper.id}`"
        :twpmapper="twpmapper"
        class="ma-2"
        @changeMapper="updateUObject({
            url: [
              {projects: $route.params.project_id},
              {autopilotprojects: $route.params.autopilot_id},
              {twpmappers: twpmapper.id}
            ],
            update: $event
          })"
        @deleteMapper="deleteUObject({
            url: [
              {projects: $route.params.project_id},
              {autopilotprojects: $route.params.autopilot_id},
              {twpmappers: twpmapper.id}
            ]
          })"
      />
      <TWPMapper
        class="ma-2"
        @changeMapper="createUObject({
          url: [
            {projects: $route.params.project_id},
            {autopilotprojects: $route.params.autopilot_id},
            {twpmappers: ''},
            {showWithEntitiesNormalized: ''},
          ],
          u_object: $event
        })" />
    </TFlex>

    <!-- ISSUES FOR THIS PILOT -->
    <TText
      :text="'Issues'"
      font_weight="500"
      size="24"
    />
    <TFlex wrap="wrap">
      <v-card
      v-for="issue in autopilotissues_filtered"
      :key="`issue${issue.id}`"
      class="ma-2"
      :color="issue.parent.color"
      :style="`color: ${issue.parent.textcolor}`"
      max-width="344"
      >
      <div v-if="issue.parent_type === 'twork_package'">
        <WorkPackageHead
          :head="{
            token: issue.parent.token,
            name: issue.parent.name,
            icon: issue.parent.icon,
            area: issue.parent.taktarea_name,
            status_done_count: $store.state.Ultra.status_array.findIndex(status => status.name === issue.parent.status),
            status_is_stop: issue.parent.stop_status,
          }"
          :foreground_color="getColor(issue.parent.textcolor)"
          :readonly="true"
          />
        <!-- <v-card-title></v-card-title> -->
        <v-card-subtitle>ISSUE.status: <b>{{ issue.status }}</b></v-card-subtitle>
        <v-card-text>
          {{ issue.logentries[0].value }}
        </v-card-text>
          <v-card-actions>
            <v-btn @click="updateUObject({
              url: [
                { projects: project_id },
                { autopilotissues: issue.id },
              ],
              update: { status: issue.status === 'resolved' ? 'open' : 'resolved' }
              })"
            >
                {{ issue.status === 'resolved' ? 'reopen' : 'resolve' }}
            </v-btn>
            <v-btn @click="routeToParent(issue)">go to work package</v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </TFlex>
  </div>
</template>

<script>
  import {  mapGetters, mapActions } from 'vuex';
  import TText from '@/components/Taktify/TText.component.vue';
  import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';
  import TFlex from '@/components/Taktify/TFlex.component.vue';
  import WorkPackageHead from '@/modules/WorkPackageWIP/WorkPackageHead.module.vue';
  import TWPMapper from '@/modules/Project/TWPMapper.module.vue';

  // import RadioKnobRow from '@/modules/WorkPackageWIP/RadioKnobRow.module.vue';
  import { TColor } from '@/mixins/TColor.mixin.js'

  export default {
    components: {
      TText,
      ButtonOutlined,
      TFlex,
      WorkPackageHead,
      TWPMapper
      // RadioKnobRow,
    },

    mixins: [TColor],

    props: [],

    created(){
      this.requestUObject({
        url: [
          {projects: this.$route.params.project_id},
          {autopilotprojects: this.$route.params.autopilot_id},
          {twpmappers: ''},
          {showWithEntitiesNormalized: ''},
        ]
      })
    },

    data: () => ({

    }),

    computed: {
      ...mapGetters('Ultra', [
        'getUObjectsFiltered',
        'getUObject',
        'getUObjects',
      ]),
      autopilotprojects() {
        return this.$store.state.Ultra.autopilotprojects[this.$route.params.autopilot_id];
      },

      autopilot() {
        if (this.autopilotprojects) {
          return this.$store.state.Ultra.autopilots[this.autopilotprojects.autopilots[0]];
        } else {
          return {};
        }
      },

      project_id() {
        return this.$route.params.project_id;
      },

      autopilotissues_filtered(){
        let self = this;
        return self.getUObjects({type: 'autopilotissues'}).filter(issue => {
          return issue.autopilot.function === self.autopilot.function;
        });
      }
    },

    methods: {
      ...mapActions('Ultra', [
        'requestUObject',
        'createUObject',
        'updateUObject',
        'deleteUObject'
      ]),
      routeToParent(issue){
        // console.log('issue', issue);
        switch (issue.parent_type) {
          case 'twork_package':
            this.$router.push({
              name: 'TaktPlanWorkPackageInfo',
              params: {
                project_id: this.project_id,
                train_id: issue.parent.train_id,
                taktarea_id: issue.parent.taktarea_id,
                twaggon_id: issue.parent.twaggon_id,
                tworkpackage_id: issue.parent.id,
              }
            });
            break;
        }
      },
    },
  }
</script>

<style>
  .project-autopilots-details-head {
    display: flex;
    grid-gap: 8px;
    align-items: center;
  }
  .project-autopilots-details {
    margin: 16px;
    display: flex;
    flex-direction: column;
    grid-gap: 8px;
  }
</style>
